var render, staticRenderFns
import script from "./SegmentedControl.vue?vue&type=script&lang=js"
export * from "./SegmentedControl.vue?vue&type=script&lang=js"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&id=546d21b4&prod&lang=css"


/* normalize component */
import normalizer from "!../consult/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports